var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"el",staticClass:"bcx-absolute-transition",class:_setup.isSlideAnimation && 'slide-timings',style:(_setup.style)},[_c('transition',{attrs:{"name":_vm.name},on:{"enter":_setup.onEnter,"after-leave":_setup.onAfterTransition,"enter-cancelled":_setup.onEnterCancelled}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }